<template>
    <div class="compress__container" ref="container" @mousedown="mousedownHanlder" @click="watchDetail">
        <img  :src="require('./zip.svg')" ref="zip" alt=""/>
        <div class="numbers" v-show="Array.isArray(zipList) && zipList.length > 0">{{zipList.length}}</div>
        <div class="details" ref="details"  v-show="detailShow">
            <div class="detail" v-show="Array.isArray(zipList) && zipList.length > 0" v-for="(item, index) in zipList" :key="index">
                <span :title="item.name" style="width:80px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.name}}</span>
                <el-progress :percentage="item.percent" style="width:200px;margin-left:5px;"></el-progress>
            </div>
            <div style="height:100%;width:100%;display:flex;align-items:center;justify-content:center;" v-show="!Array.isArray(zipList) || zipList.length <= 0" >
                <img :src="require('./empty.svg')" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const PADDING = 5
export default {
    data: () => {
        return {
            number: 0,
            detailShow: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.zip && (this.$refs.zip.ondragstart=function (){return false;});
        })
    },
    computed:{
        ...mapState({
            zipList : (state) => state.zip.zipList
        })
    },
    methods: {
        watchDetail(event) {
            const node = event.currentTarget
            this.detailShow = !this.detailShow
            this.refreshLocation(node,event)
        },
        refreshLocation(node, event) {
            if (this.$parent.$el) {
              const xLeave = this.$parent.$el.offsetWidth - event.pageX - node.offsetWidth - 2*PADDING - 300
              const xFrom = node.offsetLeft -  - node.offsetWidth - 2*PADDING - 300
              const yLeave = this.$parent.$el.offsetHeight - event.pageY -  node.offsetHeight - 2*PADDING - 300
              const yFrom = node.offsetTop -  node.offsetHeight - 2*PADDING - 300
              if (xLeave < 0 && xFrom > 0) {
                  this.$refs.details.style.left = '-300px';
                  this.$refs.details.style.right = '';

              } else{
                  this.$refs.details.style.right = '-300px';
                  this.$refs.details.style.left = '';
              } 
              if (yLeave < 0 && yFrom > 0)  {
                  this.$refs.details.style.top = '-300px';
                  this.$refs.details.style.bottom = '';
              } else {
                   this.$refs.details.style.bottom = '-300px';
                   this.$refs.details.style.top = '';
              }
            }
        },
        mousedownHanlder(event) {
            const node = event.currentTarget
            const xbias = event.pageX - node.offsetLeft
            const ybias = event.pageY - node.offsetTop
            let maxWidth, maxHeight
            if (this?.$parent?.$el) {
                maxWidth = this.$parent.$el.offsetWidth - node.offsetWidth - PADDING
                maxHeight = this.$parent.$el.offsetHeight - node.offsetHeight - PADDING
            }
            const _this = this
            function moveHandler(e) {
                let left = e.pageX - xbias > PADDING ? e.pageX - xbias : PADDING
                let top = e.pageY - ybias > PADDING ?  e.pageY - ybias : PADDING 
                if (maxWidth && left >= maxWidth) left = maxWidth
                if (maxHeight && top >= maxHeight) top = maxHeight
                console.log(maxWidth, maxHeight, left, top)
                node.style.left = left + 'px'
                node.style.top = top + 'px'
                _this.$nextTick(() => _this.refreshLocation(node, e))
            }
            function upHandler(e) {
                document.removeEventListener('mousemove', moveHandler)
                document.removeEventListener('mouseup', upHandler)
                _this.$nextTick(() => _this.refreshLocation(node, e))
            }
            document.addEventListener('mousemove', moveHandler)
            document.addEventListener('mouseup', upHandler)

        }
    }
}
</script>

<style lang="scss" scoped>
.compress__container {
    position: absolute;
    right: 30px;
    top: 80%;
    z-index: 11;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0px 1px 7px 4px #d7d7e7;
    &:hover{
        cursor: pointer;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        height: 60%;
        width: 60%;
        user-select: none;
    }
    .numbers {
        position: absolute;
        top: 0;
        right: 0;
        min-height: 20px;
        min-width: 20px;
        border-radius: 50%;
        background: red;
        display: flex;
        align-items: center;
        overflow: hidden;
        justify-content: center;
        color: #fff;
        box-shadow: 0px 0px 2px 3px #f9838394;

    }
    $fix_height: 300px;
    $fix_width:300px;
    .details {
        position: absolute;
        // top: -#{$fix_height};
        // left: -#{$fix_width};
        width: $fix_width;
        height: $fix_height;
        overflow: hidden auto;
        background: #fff;
        box-shadow: 0px 1px 7px 4px #d7d7e7;
        border-radius: 4px;
        padding: 10px;
        box-sizing: border-box;
        .detail {
            padding: 10px 0px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }
    }
}
</style>